<template>
  <div class="item">
    <NuxtImg
      :src="item.icon"
      alt="carousel-icon"
    />
    <p class="title">{{ item.title }}</p>
    <p class="description">{{ item.description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import './Item.scss';
</style>
